import { render, staticRenderFns } from "./Allauthorized.vue?vue&type=template&id=dd8353a4"
import script from "./Allauthorized.vue?vue&type=script&lang=js"
export * from "./Allauthorized.vue?vue&type=script&lang=js"
import style0 from "./Allauthorized.vue?vue&type=style&index=0&id=dd8353a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports